import { render, staticRenderFns } from "./TableAgentePosVendaAssociado.vue?vue&type=template&id=28f88b30&scoped=true&"
import script from "./TableAgentePosVendaAssociado.vue?vue&type=script&lang=js&"
export * from "./TableAgentePosVendaAssociado.vue?vue&type=script&lang=js&"
import style0 from "./TableAgentePosVendaAssociado.vue?vue&type=style&index=0&id=28f88b30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f88b30",
  null
  
)

export default component.exports